export const VARICON_DOMAIN = '@varicon.com.au';
export const VARICON_BASE_URL = 'https://varicon.com.au';

export const MODULE = {
  // users
  USERS: 'USERS',

  // bills
  BILLS: 'BILLS',
  BILLS_APPROVAL_WORKFLOW: 'BILLS_APPROVAL_WORKFLOW',

  // leave
  LEAVE: 'LEAVE',

  // pay rules
  PAY_RULES: 'PAY_RULES',

  // scheduler
  SCHEDULER: 'SCHEDULER',

  // purchase order
  PURCHASE_ORDER: 'PURCHASE_ORDER',

  // dashboard
  DASHBOARD: 'DASHBOARD',

  // employee
  EMPLOYEE: 'EMPLOYEE',

  // timesheet
  TIMESHEET: 'TIMESHEET',

  // daily cost tracking
  DAILY_COST_TRACKING: 'DAILY_COST_TRACKING',

  // timesheet matrix
  TIMESHEET_MATRIX: 'TIMESHEET_MATRIX',

  // delivery docket
  DELIVERY_DOCKET: 'DELIVERY_DOCKET',

  // site diary
  SITEDIARY: 'SITEDIARY',

  // forecast
  FORECAST: 'FORECAST',

  // fctc
  FCTC: 'FCTC',

  // production tracking
  PRODUCTION_TRACKING: 'PRODUCTION_TRACKING',

  // claim
  CLAIM: 'CLAIM',
  CLAIM_SETTING: 'CLAIM_SETTING',
  SETTING_UP_VARIATION_IN_CLAIM: 'SETTING_UP_VARIATION_IN_CLAIM',

  // project budget
  PROJECT: 'PROJECT',

  // equipment
  EQUIPMENT: 'EQUIPMENT',

  // allowance
  ALLOWANCE: 'ALLOWANCE',

  // equipment type
  EQUIPMENT_TYPE: 'EQUIPMENT_TYPE',

  // timesheet settings
  TIMESHEET_SETTINGS: 'TIMESHEET_SETTINGS',

  // purchase order settings
  PURCHASE_ORDER_SETTINGS: 'PURCHASE_ORDER_SETTINGS',

  // roles and permissions
  ROLES_AND_PERMISSIONS: 'ROLES_AND_PERMISSIONS',

  // accounting codes
  ACCOUNTING_CODES: 'ACCOUNTING_CODES',

  // resource assigner
  RESOURCE_ASSIGNER: 'RESOURCE_ASSIGNER',

  // accounting integration settings
  ACCOUNTING_INTEGRATION_SETTINGS: 'ACCOUNTING_INTEGRATION_SETTINGS',

  // custom forms
  CUSTOM_FORMS: 'CUSTOM_FORMS',

  // daywork record
  DAYWORK_DOCKET: 'DAYWORK_DOCKET',

  // variation register
  VARIATION_REGISTER: 'VARIATION_REGISTER',

  // report
  REPORT: 'REPORT',

  // resource
  RESOURCE: 'RESOURCE',

  //Estimation Sheet
  ESTIMATION_SHEET: 'ESTIMATION_SHEET',
  EXPERT_ESTIMATOR: 'EXPERT_ESTIMATOR_KB_URL',

  // Asset Management
  ASSET_MANAGEMENT: 'ASSET_MANAGEMENT',
  EQUIPMENT_REGISTRY: 'EQUIPMENT_REGISTRY',
  ASSET_TYPE: 'ASSET_TYPE',
};

export const AUDIT_LOG_SORT_ORDER = {
  NEW: 'desc',
  OLD: 'asc',
} as const;
